
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../services/api";
import io from "socket.io-client";
import ServicosList from "./ServicosList";
import FolgasList from "./FolgasList";
import FuncionariosList from "./FuncionarioList";
import AgendamentosList from "./AgendamentoList";
import HorariosExcluidosList from "./HorariosExcluidosList";
import {
  FaSignOutAlt,
  FaShieldAlt,
  FaKey,
  FaBars,
  FaTimes,
  FaChartLine,
  FaCalendarAlt,
  FaConciergeBell,
  FaUserTie,
  FaCoffee,
  FaClock,
  FaCalendarCheck,
  FaCamera,
  FaChevronDown,
} from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentSettingsTenant from "../components/PaymentSettingsTenant";
import "../App.css";

const Dashboard = () => {
  const [agendamentos, setAgendamentos] = useState([]);
  const [funcionarios, setFuncionarios] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [folgas, setFolgas] = useState([]);
  const [menuAberto, setMenuAberto] = useState(false);
  const [mensagemSucesso, setMensagemSucesso] = useState("");
  const [erro, setErro] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const barbearia_id = sessionStorage.getItem("barbearia_id");

    const socket = io("https://acesso.cronosagenda.com.br", {
      path: "/socket.io/",
      transports: ["websocket"],
      query: { barbearia_id },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });

    socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    socket.on("connect_error", (error) => {
      console.error("Erro de conexão:", error);
    });

    socket.on("disconnect", () => {
      console.log("Desconectado do servidor");
    });

    socket.on("reconnect", (attemptNumber) => {
      console.log(
        `Reconectado ao servidor após ${attemptNumber} tentativas`
      );

      socket.emit("update_barbearia_id", {
        barbearia_id: sessionStorage.getItem("barbearia_id"),
      });
    });

    const disableContextMenu = (event) => event.preventDefault();
    document.addEventListener("contextmenu", disableContextMenu);

    const disableShortcuts = (event) => {
      if (
        (event.ctrlKey && event.shiftKey && event.key === "I") ||
        (event.ctrlKey && event.key === "U")
      ) {
        event.preventDefault();
      }

      if (event.key === "F12") {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", disableShortcuts);

    const checkAuth = async () => {
      try {
        await api.get("/verificar-autenticacao", {
          withCredentials: true,
        });
      } catch (err) {
        navigate("/login");
      }
    };

    checkAuth();

    const fetchData = async (endpoint, setState, errorMessage) => {
      try {
        const response = await api.get(endpoint, {
          withCredentials: true,
        });

        setState(response.data);
      } catch (err) {
        setErro(
          err.response
            ? `Erro: ${err.response.data.error}`
            : errorMessage
        );
      }
    };

    fetchData(
      "/funcionarios",
      setFuncionarios,
      "Erro ao carregar os funcionários."
    );

    fetchData(
      "/servicos",
      setServicos,
      "Erro ao carregar os serviços."
    );

    fetchData("/folgas", setFolgas, "Erro ao carregar as folgas.");

    fetchData(
      "/agendamentos",
      setAgendamentos,
      "Erro ao carregar os agendamentos."
    );

    socket.on("atualizar_agendamentos", () => {
      fetchData(
        "/agendamentos",
        setAgendamentos,
        "Erro ao carregar os agendamentos."
      );
    });

    socket.on("novo_agendamento", (data) => {
      toast.success(
        `Novo agendamento de ${data.cliente_nome} para ${data.data} às ${data.hora}.`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );

      const audio = new Audio("/notification-sound.mp3");

      audio.play().catch((error) => {
        console.error("Erro ao reproduzir o áudio:", error);
      });
    });

    return () => {
      socket.off("connect");
      socket.off("connect_error");
      socket.off("atualizar_agendamentos");
      socket.off("novo_agendamento");
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("keydown", disableShortcuts);
    };
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await api.post("/logout", {}, { withCredentials: true });
      sessionStorage.clear();
      navigate("/login");
    } catch (err) {
      console.error("Erro ao fazer logout:", err);
    }
  };

  const handleExcluirAgendamento = async (id) => {
    try {
      await api.delete(`/agendamentos/${id}`, {
        withCredentials: true,
      });

      setAgendamentos((prevAgendamentos) =>
        prevAgendamentos.filter((agendamento) => agendamento.id !== id)
      );
    } catch (err) {
      setErro(
        err.response
          ? `Erro: ${err.response.data.error}`
          : "Erro ao excluir o agendamento."
      );
    }
  };

  const handleExcluirFuncionario = async (id) => {
    try {
      await api.delete(`/funcionarios/${id}`, {
        withCredentials: true,
      });

      setFuncionarios((prevFuncionarios) =>
        prevFuncionarios.filter((funcionario) => funcionario.id !== id)
      );
    } catch (err) {
      setErro(
        err.response
          ? `Erro: ${err.response.data.error}`
          : "Erro ao excluir o funcionário."
      );
    }
  };

  const handleMarkAsCompleted = async (id) => {
    try {
      await api.post(
        `/agendamentos/concluir/${id}`,
        {},
        { withCredentials: true }
      );

      setMensagemSucesso("Agendamento marcado como concluído!");

      setTimeout(() => setMensagemSucesso(""), 3000);

      setAgendamentos((prevAgendamentos) =>
        prevAgendamentos.filter((agendamento) => agendamento.id !== id)
      );
    } catch (err) {
      setErro(
        err.response
          ? `Erro: ${err.response.data.error}`
          : "Erro ao marcar agendamento como concluído."
      );
    }
  };

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  return (
    <main className="cronos-dashboard">
      <ToastContainer />

      {mensagemSucesso && (
        <div className="cronos-success-message" role="status">
          <FaCalendarCheck />
          <span>{mensagemSucesso}</span>
        </div>
      )}

      <header className="cronos-header">
        <div className="cronos-header-brand">
          <img
            src="/logo_cronos.png"
            alt="Cronos Agenda"
            className="cronos-logo"
          />

          <div className="cronos-brand-copy">
            <span className="cronos-brand-title">Cronos Agenda</span>
            <span className="cronos-brand-subtitle">
              Gestão do seu negócio
            </span>
          </div>
        </div>

        <div className="cronos-header-actions">
          <div className="cronos-menu-wrapper">
            <button
              type="button"
              onClick={toggleMenu}
              className={`cronos-menu-trigger ${
                menuAberto ? "is-open" : ""
              }`}
              aria-expanded={menuAberto}
            >
              {menuAberto ? <FaTimes /> : <FaBars />}
              <span>Menu</span>
              <FaChevronDown className="cronos-menu-chevron" />
            </button>

            {menuAberto && (
              <>
                <button
                  type="button"
                  className="cronos-menu-backdrop"
                  aria-label="Fechar menu"
                  onClick={toggleMenu}
                />

                <nav className="cronos-dropdown" aria-label="Menu principal">
                  <span className="cronos-dropdown-heading">
                    NAVEGAÇÃO
                  </span>

                  <Link to="/agendamentos/new" className="cronos-dropdown-link">
                    <FaCalendarAlt />
                    <span>Criar novo agendamento</span>
                  </Link>

                  <Link to="/servicos/new" className="cronos-dropdown-link">
                    <FaConciergeBell />
                    <span>Adicionar serviço</span>
                  </Link>

                  <Link to="/folgas/new" className="cronos-dropdown-link">
                    <FaCoffee />
                    <span>Adicionar folga</span>
                  </Link>

                  <div className="cronos-dropdown-divider" />

                  <Link
                    to="/excluir_horarios/new"
                    className="cronos-dropdown-link"
                  >
                    <FaClock />
                    <span>Excluir horários</span>
                  </Link>

                  <Link
                    to="/gerenciar_horarios"
                    className="cronos-dropdown-link"
                  >
                    <FaCalendarAlt />
                    <span>Consultar horários</span>
                  </Link>

                  <Link
                    to="/gerenciar_horarios_funcionamento"
                    className="cronos-dropdown-link"
                  >
                    <FaClock />
                    <span>Horários e pausas</span>
                  </Link>

                  <Link
                    to="/agendamentos/concluidos/new"
                    className="cronos-dropdown-link"
                  >
                    <FaCalendarCheck />
                    <span>Agendamentos concluídos</span>
                  </Link>

                  <Link to="/upload-foto" className="cronos-dropdown-link">
                    <FaCamera />
                    <span>Upload de fotos</span>
                  </Link>

                  <div className="cronos-dropdown-divider" />

                  <Link
                    to="/dashboard-admin"
                    className="cronos-dropdown-link"
                  >
                    <FaChartLine />
                    <span>Painel financeiro</span>
                  </Link>

                  <Link
                    to="/cl13nt/configuracoes-2fa"
                    className="cronos-dropdown-link"
                  >
                    <FaShieldAlt />
                    <span>Configurações 2FA</span>
                  </Link>
                </nav>
              </>
            )}
          </div>

          <Link
            to="/alterar-senha"
            className="cronos-header-button cronos-password-button"
          >
            <FaKey />
            <span>Alterar senha</span>
          </Link>

          <button
            type="button"
            onClick={handleLogout}
            className="cronos-header-button cronos-logout-button"
          >
            <FaSignOutAlt />
            <span>Sair</span>
          </button>
        </div>
      </header>

      <section className="cronos-welcome">
        <div className="cronos-welcome-copy">
          <span className="cronos-eyebrow">PAINEL DE CONTROLE</span>
          <h1>Visão geral</h1>
          <p>
            Gerencie seus agendamentos, serviços e equipe em um só lugar.
          </p>
        </div>

        <div className="cronos-welcome-decoration" aria-hidden="true">
          <div className="cronos-decoration-icon">
            <FaCalendarCheck />
          </div>
        </div>
      </section>

      <section className="cronos-payment-section">
        <PaymentSettingsTenant />
      </section>

      <section className="cronos-dashboard-section cronos-appointments-section">
        <div className="cronos-section-heading">
          <div className="cronos-section-icon">
            <FaCalendarAlt />
          </div>
          <div>
            <h2>Agendamentos</h2>
            <p>Acompanhe e gerencie os atendimentos.</p>
          </div>
        </div>

        <div className="cronos-section-content">
          <AgendamentosList
            agendamentos={agendamentos}
            erro={erro}
            navigate={navigate}
            handleExcluirAgendamento={handleExcluirAgendamento}
            handleMarkAsCompleted={handleMarkAsCompleted}
          />
        </div>
      </section>

      <div className="cronos-management-grid">
        <section className="cronos-dashboard-section">
          <div className="cronos-section-heading">
            <div className="cronos-section-icon">
              <FaConciergeBell />
            </div>
            <div>
              <h2>Serviços</h2>
              <p>Seus serviços e respectivos valores.</p>
            </div>
          </div>

          <div className="cronos-section-content">
            <ServicosList servicos={servicos} />
          </div>
        </section>

        <section className="cronos-dashboard-section">
          <div className="cronos-section-heading">
            <div className="cronos-section-icon">
              <FaUserTie />
            </div>
            <div>
              <h2>Profissionais</h2>
              <p>Gerencie sua equipe.</p>
            </div>
          </div>

          <div className="cronos-section-content">
            <FuncionariosList
              funcionarios={funcionarios}
              handleExcluirFuncionario={handleExcluirFuncionario}
            />
          </div>
        </section>

        <section className="cronos-dashboard-section">
          <div className="cronos-section-heading">
            <div className="cronos-section-icon">
              <FaCoffee />
            </div>
            <div>
              <h2>Folgas</h2>
              <p>Consulte as folgas cadastradas.</p>
            </div>
          </div>

          <div className="cronos-section-content">
            <FolgasList folgas={folgas} />
          </div>
        </section>

        <section className="cronos-dashboard-section">
          <div className="cronos-section-heading">
            <div className="cronos-section-icon">
              <FaClock />
            </div>
            <div>
              <h2>Horários excluídos</h2>
              <p>Consulte os bloqueios de horário.</p>
            </div>
          </div>

          <div className="cronos-section-content">
            <HorariosExcluidosList />
          </div>
        </section>
      </div>

      <footer className="cronos-dashboard-footer">
        <span>© Cronos Agenda</span>
        <span>Gestão simples, organizada e eficiente.</span>
      </footer>
    </main>
  );
};

export default Dashboard;

// Developed by: ruansk7
